module.exports = __webpack_public_path__ + "img/cylinder-double.a315f978.png";